/// #if PLATFORM === 'xd'
<template>
  <div class="h-100">
    <!-- Main HTML -->
    <AppHeader />

    <div class="pageContainer">
      <router-view />
    </div>

    <AppFooter />
    <!-- Common Message -->
    <Message />
  </div>
</template>
/// #else
<template>
  <div>
    <!-- Adds Theme Variables in the :root CSS -->
    <!-- <component :is="theme" /> -->

    <!-- Main HTML -->
    <AppHeader />

    <keep-alive :max="10">
      <router-view :key="$route.fullPath"/>
    </keep-alive>

    <AppFooter />

    <!-- Modals -->
    <modal-import-format
      v-if="modalName === 'modalImportFormat'"
      v-bind="modalData"
    />

    <!-- Common Message -->
    <message />

    <!-- Update Message -->
    <update-available />
  </div>
</template>
/// #endif

<script>
import { mapState } from 'vuex'
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Message from '@/components/Message'
import UpdateAvailable from '@/components/UpdateAvailable'
import ModalImportFormat from '@/modals/ImportFormat'

export default {
  components: {
    AppHeader,
    AppFooter,
    Message,
    UpdateAvailable,
    ModalImportFormat
  },

  computed: {
    ...mapState({
      modalName: state => state.modal.name,
      modalData: state => state.modal.data
    })
  },

  created () {
    window.addEventListener('resize', () => {
      this.$store.commit('scroll/setWindowHeight', window.innerHeight)
    })
  },

  mounted () {
    // Register Modal hidden handler
    this.$root.$on('bv::modal::shown', (event, id) => {
      this.$amplitude.getInstance().logEvent('shownModal', { id })
    })

    this.$root.$on('bv::modal::hidden', (event, id) => {
      this.$store.commit('modal/hide', id)

      this.$amplitude.getInstance().logEvent('hiddenModal', { id })
    })
  }
}
</script>
